(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luma-first-88"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-luma-gift]');
    if (!root) return;
    const giftId = Number(root.dataset.variant);
    const base = root.dataset.root;
    const words = JSON.parse(root.querySelector('[data-gift-text]').textContent);
    const eligibleProducts = new Set([15898277413245,15989722415485,16005592220029,16022412198269,16022412231037,16022412296573,16022412362109]);
    const permitted = new WeakSet();
    let task = null, dirty = false, lastMessage = '', giftAvailable = root.dataset.available === 'true';
    document.documentElement.classList.add('luma-gift-cart-first');
    let stockPending = false, stockChecked = 0;
    async function refreshStock() {
      if (document.hidden || stockPending || Date.now()-stockChecked<55000 || !root.querySelector('[data-gift-stock],[data-gift-popup]')) return;
      stockPending = true;
      try {
        const response = await fetch(base+'?section_id='+encodeURIComponent(root.dataset.section),{credentials:'same-origin',cache:'no-store'});
        if (!response.ok) return;
        const next = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-luma-gift]');
        if (!next) return;
        const available = next.dataset.available === 'true';
        root.dataset.available = String(available);
        if (!available) root.querySelector('[data-gift-popup][open]')?.close();
        root.querySelectorAll('.luma-gift__hero,.luma-gift__bar').forEach(node=>{node.hidden=!available;});
        const currentStock = root.querySelector('[data-gift-stock]'), nextStock = next.querySelector('[data-gift-stock]');
        if (currentStock && nextStock && currentStock.innerHTML !== nextStock.innerHTML) currentStock.replaceWith(nextStock);
        const popupStock = root.querySelector('[data-popup-stock]'), freshPopupStock = next.querySelector('[data-popup-stock]');
        if (popupStock && freshPopupStock && popupStock.innerHTML !== freshPopupStock.innerHTML) popupStock.replaceWith(freshPopupStock);
        stockChecked = Date.now();
      } catch(error) {} finally { stockPending = false; }
    }
    if (root.querySelector('[data-gift-stock],[data-gift-popup]')) {
      setInterval(refreshStock,60000);
      document.addEventListener('visibilitychange',refreshStock);
      window.addEventListener('pageshow',refreshStock);
      refreshStock();
    }
    const popup = root.querySelector('[data-gift-popup]');
    if (popup && typeof popup.showModal === 'function') {
      const seenKey = 'luma-first88-relaunch-seen';
      let seen = false, opening = false;
      try { seen = sessionStorage.getItem(seenKey) === '1'; } catch(error) {}
      popup.querySelectorAll('[data-gift-popup-close]').forEach(button=>button.addEventListener('click',()=>popup.close()));
      popup.addEventListener('click',event=>{if(event.target===popup){const rect=popup.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)popup.close();}});
      popup.addEventListener('close',()=>document.documentElement.classList.remove('luma-launch-open'));
      popup.querySelector('[data-gift-popup-shop]')?.addEventListener('click',()=>popup.close());
      async function openPopup() {
        if (opening || popup.open || document.hidden || root.dataset.available !== 'true') return;
        opening = true;
        try {
          const product = await request('products/patches.js');
          if (!product.variants.some(variant=>variant.id===giftId&&variant.available)) return;
          if (document.hidden || !popup.isConnected || document.querySelector('dialog[open]')) return;
          popup.showModal();
          document.documentElement.classList.add('luma-launch-open');
          seen = true;
          try { sessionStorage.setItem(seenKey,'1'); } catch(error) {}
        } catch(error) {} finally { opening = false; }
      }
      root.querySelector('[data-gift-popup-trigger]')?.addEventListener('click',event=>{event.preventDefault();openPopup();});
      let attempts = 0;
      function welcome() {
        if (seen || root.dataset.designMode === 'true') return;
        if (document.hidden || document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]')) {
          if (++attempts<15) setTimeout(welcome,2000);
          return;
        }
        openPopup();
      }
      setTimeout(welcome,15000);
    }
    function message(text) {
      lastMessage = text;
      for (const target of document.querySelectorAll('.cart-totals')) {
        let node = target.querySelector('.luma-gift-status');
        if (!node) { node = document.createElement('div'); node.className = 'luma-gift-status'; node.setAttribute('aria-live','polite'); target.prepend(node); }
        if (node.textContent !== text) node.textContent = text;
      }
      const form = document.querySelector('#es-form');
      if (form && !form.querySelector('.luma-form-note')) {
        const note = document.createElement('p');
        note.className = 'luma-form-note luma-gift-status';
        note.append(document.createTextNode(words.formNote+' '));
        const link = document.createElement('a'); link.href=base+'cart'; link.textContent=words.edit;
        note.append(link); form.querySelector('.es-form-header')?.after(note);
      }
    }
    async function request(path, body) {
      const response = await fetch(base + path, {method:body?'POST':'GET',headers:{'Content-Type':'application/json'},credentials:'same-origin',cache:'no-store',...(body?{body:JSON.stringify(body)}:{})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'cart-request-failed');
      return result;
    }
    function sections() { return [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n=>n.dataset.sectionId))].slice(0,5); }
    async function update(updates) { return request('cart/update.js',{updates,sections:sections(),sections_url:location.pathname}); }
    async function showCart(cart) {
      const {CartUpdateEvent} = await import('@theme/events');
      document.dispatchEvent(new CartUpdateEvent(cart,'luma-first-88',{source:'luma-first-88',itemCount:cart.item_count,sections:cart.sections||{}}));
    }
    async function reconcile() {
      let cart = await request('cart.js');
      const availability = await request('products/patches.js');
      giftAvailable = availability.variants.some(v=>v.id===giftId&&v.available);
      const subtotal = cart.items.filter(i=>eligibleProducts.has(i.product_id)).reduce((sum,i)=>sum+i.final_line_price,0);
      const gifts = cart.items.filter(i=>i.variant_id===giftId);
      const autoGifts = gifts.filter(i=>i.properties?._luma_first_88==='true');
      const eligible = subtotal>=10000 && giftAvailable;
      let changed=false;
      if (!eligible && autoGifts.length) {
        cart=await update(Object.fromEntries(autoGifts.map(i=>[i.key,0])));changed=true;
      } else if (eligible && !gifts.length) {
        message(words.pending);
        const product=await request('products/patches.js');
        giftAvailable=product.variants.some(v=>v.id===giftId&&v.available);
        if (giftAvailable) {
          try { await request('cart/add.js',{items:[{id:giftId,quantity:1,properties:{_luma_first_88:'true'}}]});cart=await update({});changed=true; }
          catch(error){ const fresh=await request('products/patches.js');giftAvailable=fresh.variants.some(v=>v.id===giftId&&v.available);if(giftAvailable)throw error; }
        }
      } else if (eligible && (autoGifts.some(i=>i.quantity!==1) || autoGifts.length>1)) {
        cart=await update(Object.fromEntries(autoGifts.map((i,index)=>[i.key,index===0?1:0])));changed=true;
      }
      const finalGift=cart.items.find(i=>i.variant_id===giftId);
      if(finalGift?.properties?._luma_first_88==='true' && finalGift.final_line_price!==0){cart=await update({[finalGift.key]:0});changed=true;message(words.unavailable);}
      else if(finalGift?.final_line_price===0)message(words.ready);
      else if(!giftAvailable)message(words.unavailable);
      else if(subtotal<10000)message(words.below.replace('[sum]',new Intl.NumberFormat('ro-RO',{maximumFractionDigits:2}).format((10000-subtotal)/100)));
      else message(words.unavailable);
      if(changed)await showCart(cart);
      return cart;
    }
    function sync() {
      if(task){dirty=true;return task;}
      document.documentElement.classList.add('luma-gift-busy');
      task=(async()=>{let cart;do{dirty=false;cart=await reconcile();}while(dirty);return cart;})().catch(error=>{message(words.error);throw error;}).finally(()=>{task=null;document.documentElement.classList.remove('luma-gift-busy');});
      return task;
    }
    document.addEventListener('cart:update',event=>{if(event.detail?.sourceId!=='luma-first-88')sync().catch(()=>{});});
    document.addEventListener('discount:update',()=>sync().catch(()=>{}));
    window.addEventListener('pageshow',()=>sync().catch(()=>{}));
    new MutationObserver(()=>message(lastMessage)).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',async event=>{
      if(event.target.closest('#es-form .es-line-item .es-close')) {
        event.preventDefault();event.stopImmediatePropagation();location.assign(base+'cart');return;
      }
      const button=event.target.closest('[name="checkout"],a[href="/checkout"],.es-popup-button-cart');
      if(!button)return;
      if(permitted.has(button)){permitted.delete(button);return;}
      event.preventDefault();event.stopImmediatePropagation();
      try{await sync();if(button.matches('.es-popup-button-cart')){const current=document.querySelector('.es-popup-button-cart');if(current){permitted.add(current);current.click();}}else{location.assign(base+'checkout?locale=ro');}}catch(error){}
    },true);
    document.addEventListener('submit',async event=>{
      if(!event.target.matches('form[action="/cart"]') || event.submitter?.name!=='checkout')return;
      event.preventDefault();event.stopImmediatePropagation();
      try{await sync();location.assign(base+'checkout?locale=ro');}catch(error){}
    },true);
    sync().catch(()=>{});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
